import React from "react";
import { observer } from "mobx-react";
import { TextFieldMask } from "../components";
import { getStyle } from "Utils";
import DivCss from "../components/divCss";
import "../index.css";
import { TooltipIcon } from "TemplateCerere";

function Field3(props) {
  const { item, inline, actions } = props;

  //const styleProps = getStyle(item.eventProps);
  
  const infoLabel = item?.Jprop?.infoLabel;
  return (
    item.isVisible && (
      <DivCss {...props} id={`f3-${item.Id}`} key={item.Id}>
        {!inline && (
          <div id={`f3l-${item.Id}`} className="doc-field-label">
            {item.Caption + (item.Obligatoriu ? " *" : "")}
            {infoLabel && <TooltipIcon tooltip={infoLabel} />}
          </div>
        )}
        <TextFieldMask
          id={`f3f-${item.Id}`}
          defaultValue={item.Valoare}
          onBlur={(prop) => actions.updateValue(item, prop.target.value)}
          label={inline ? item.Caption : null}
          disabled={item.isReadonly || item.docReadOnly}
          className={item.isReadonly || item.docReadOnly ? "disabled" : null}
          variant="outlined"
          isDecimal={true}
          /// ??? decimalScale={item.Lungime}
          size="small"
          required={item.Obligatoriu}
          error={!!item.error}
          helperText={item.error || item.Jprop.helperText}
          //sx={styleProps.input}
        />
      </DivCss>
    )
  );
}
export default observer(Field3);
